export default "__VITE_ASSET__B_xTuM9P__"